window.initializeFlatPickr = function(){
  flatpickr("input[type=time]", { enableTime: true, noCalendar: true, time_24hr: true });
}

window.initializeOnlyEnableDateFlatPickr = function() {
  const dom = $('.flatpickr-enable-only')
  flatpickr(dom, { enable: dom.data("dateenable").split(",") })
}
